import { Component, Input, OnInit } from '@angular/core';
import { IChartTitleData, ILargeCardInteriorOptions } from '../../interfaces/card-data';
import { NoDataActionType } from '../../interfaces/no-data';

import * as Highcharts from 'highcharts';
import { LGDonutChartOptions } from '../../interfaces/donut-chart';
import { Router } from '@angular/router';
import { ReusableFunctions } from '../../classes/reusable-functions';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss'],
})
// TODO: Clean up this container code;
export class DonutChartComponent implements OnInit {
    // TODO: Pass these input values as one object
    //@Input() chartOptions: Highcharts.Options = donutChartOptions; // Add custom options??
    @Input() action: NoDataActionType;
    @Input() title: string;
    @Input() loading: boolean;
    @Input() data: any;
    @Input() uniqueId: string;

    @Input() accessToUrl: string = null;
    @Input() queryParams: object = null;
    @Input() dataLabels: boolean = false;
    @Input() pointClickFunction: Highcharts.PointClickCallbackFunction = null;
    @Input() legendText: any = undefined;
    @Input() twoDonutsTogether: boolean = false;
    @Input() alternateValue: boolean = false;
    @Input() updatedTooltips: boolean = false;
    @Input() minHeight: number = 300;

    largeCardOptions: ILargeCardInteriorOptions;

    /* DESIGN NOTE: For a custom set of options, we could have two methods and a boolean flag to check if 
	we need to use the custom set or not */

    constructor(
        private _router: Router,
        private reusableFunctions: ReusableFunctions,
        private decimalPipe: DecimalPipe
    ) {}

    ngOnInit() {
        this.initializeLargeCard();
    }

    ngOnChanges() {
        this.initializeLargeCard();
    }

    initializeLargeCard() {
        this.largeCardOptions = {
            action: this.action,
            componentTitle: this.title,
            searchTerm: '',
            hasData: this.data?.length > 0 && !this.loading,
            isDataReady: false,
            showTitle: true,
            accessToUrl: '',
            uniqueId: this.uniqueId,
            minHeight: this.minHeight,
        };

        if (this.data?.length > 0) {
            setTimeout(() => {
                this.setChart();
            }, 0);
        } else {
            setTimeout(() => {
                this.setChartNoData();
            }, 0);
        }
    }

    setChart() {
        let chartOptions = this.getChartOptions();
        let chartTitleData: IChartTitleData = {
            showChartCustomTitle: true,
            chartTile: this.title,
            chartLabelColor: '#dededed',
            chartComparisonValue: null,
            chartMainValue: '',
            chartSecondaryValue: '',
            isMainValueUnitVisible: false,
            chartSubItemValue: null,
            isChartSubValueVisible: false,
            svgIconString: '',
            showMainValue: false,
            comparisonStyle: null,
            isDonut: true,
        };
        this.largeCardOptions.chart = new Highcharts.Chart(this.uniqueId, chartOptions);
        this.largeCardOptions.chartTitleData = chartTitleData;
        this.largeCardOptions = Object.assign({}, this.largeCardOptions);
        if (this.accessToUrl != null) {
            this.largeCardOptions.accessToUrl = this.accessToUrl;
        }
        if (this.queryParams != null) {
            this.largeCardOptions.queryParams = this.queryParams;
        }

        if (!this.loading) {
            this.largeCardOptions.isDataReady = true;
        }
    }

    setChartNoData() {
        let chartTitleData: IChartTitleData = {
            showChartCustomTitle: true,
            chartTile: this.title,
            chartLabelColor: '#dededed',
            chartComparisonValue: null,
            chartMainValue: '',
            chartSecondaryValue: '',
            isMainValueUnitVisible: false,
            chartSubItemValue: null,
            isChartSubValueVisible: false,
            svgIconString: '',
            showMainValue: false,
            comparisonStyle: null,
            isDonut: true,
        };

        this.largeCardOptions.chartTitleData = chartTitleData;
        this.largeCardOptions = Object.assign({}, this.largeCardOptions);
        if (!this.loading) {
            this.largeCardOptions.isDataReady = true;
        }
    }

    getChartOptions(): Highcharts.Options {
        let lgDonutChart: LGDonutChartOptions = new LGDonutChartOptions(
            this._router,
            this.reusableFunctions,
            this.decimalPipe
        );

        // TODO: Change all tooltips to updated tooltips & remove need for 2 types of donut charts.
        let options: Highcharts.Options = this.twoDonutsTogether
            ? { ...lgDonutChart.getChartOptionsForTwo(this.legendText, this.alternateValue) }
            : this.updatedTooltips
            ? { ...lgDonutChart.getUpdatedChartOptions() }
            : this.legendText
            ? { ...lgDonutChart.getChartOptionsWithLegend(this.legendText) }
            : { ...lgDonutChart.getChartOptions() };
        if (options.series[0].type === 'pie') {
            options.series[0].data = this.data;
            options.plotOptions.pie.point.events.click = this.pointClickFunction;

            (
                options.plotOptions.pie.dataLabels as Highcharts.SeriesPieDataLabelsOptionsObject
            ).enabled = this.dataLabels;
        }
        return options;
    }
}
